module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3367a2e5f6357f87d291a31758e14e15.png";